import { useTranslation } from 'react-i18next';
import { useRealEstateFormContext } from '../context';
import { FormFileList, FormFileListProps } from '../../UI';

interface RealEstateFileListProps extends Pick<FormFileListProps, 'className' | 'withTitle'> {}

export function RealEstateFileList(props: RealEstateFileListProps) {
  const { t: tForm } = useTranslation('form');
  const { householdID, realEstate } = useRealEstateFormContext();

  return (
    <FormFileList
      {...props}
      tenantID={householdID}
      itemID={realEstate?.id}
      title={tForm('general-related-documents')}
    />
  );
}
